import request from '/src/api/request.js'
/**
 * 查询部门以及部门下的成员 树结构
 */
export function selectDeptAndUserTree() {
    return request({
        url: 'sys/xcxDept/listXcxDeptAndCoach',
        method: 'get'
    })
}
/**
 * 查询部门以及部门下的成员 树结构
 */
export function selectDeptTree() {
    return request({
        url: 'sys/xcxDept/selectDeptTree',
        method: 'get'
    })
}
/**
 * 根据部门id查询教练列表
 */
export function selectCoachPageByDeptId(query) {
    return request({
        url: 'sys/xcxDept/selectCoachListByDeptId',
        method: 'POST',
        data: query,
    })
}


/**
 * 新增部门
 */
export function createdDept(item) {
    return request({
        url: 'sys/xcxDept/createdDept',
        method: 'POST',
        data: item,
    })
}

/**
 * 编辑部门
 */
export function updateDept(item) {
    return request({
        url: 'sys/xcxDept/updateDept',
        method: 'POST',
        data: item,
    })
}
